// extracted by mini-css-extract-plugin
export default {"tabs":"Customtab_tabs__fstYR","tab":"Customtab_tab__16sMF","Mui-selected":"Customtab_Mui-selected__wzvS9","indicator":"Customtab_indicator__AuY2A"};